import './Header.css';

import InstallButton from './InstallButton';

const Header = ({ isLoading, isAuthenticated, currentUser, onLogin, onLogout, currentView, onViewChange }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={() => onViewChange('upload')} style={{ cursor: 'pointer' }}>
          <img src="/favicon.svg" alt="Menu AI" className="logo-icon" />
          <h1 className="logo-text">Menu AI</h1>
        </div>

        <nav className="nav-section">
          <button
            className={`nav-button ${currentView === 'pricing' ? 'active' : ''}`}
            onClick={() => onViewChange('pricing')}
          >
            Pricing
          </button>
          <InstallButton />
        </nav>

        <div className="auth-section">
          {isLoading ? (
            <div>Loading...</div>
          ) : isAuthenticated ? (
            <button onClick={onLogout} className="auth-button logout-button">
              Logout
            </button>
          ) : (
            <button onClick={onLogin} className="auth-button login-button">
              Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
